import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TableProps } from "antd";
import api from "common/api";
import { IDocument } from "common/types/common";
import { Button } from "components/ui";
import { IField } from "components/ui/filter/container/Filter";
import useQueryParams from "hooks/useQueryParams";
import React, {
  FC,
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

interface DataType extends IDocument {
  key: number;
}

export interface IEmployeesFilter {
  search: string;
}

const Context = () => {
  const navigate = useNavigate();
  const { getAllParams } = useQueryParams();
  const [data, setData] = useState<IDocument[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const { i18n } = useTranslation();

  const filterFields: IField[] = [
    {
      type: "search",
      name: "search",
    },
  ];

  const columns: TableProps<DataType>["columns"] = useMemo(
    () => [
      {
        title: "Nomi",
        dataIndex: "name",
        key: "name",
        render: (name) => name?.[i18n.language],
      },
      {
        title: "Tasnif",
        dataIndex: "description",
        key: "description",
        render: (description) => description?.[i18n.language],
      },
      {
        dataIndex: "_id",
        key: "_id",
        render: (id) => (
          <Link to={`/management/documents/create/${id}`}>
            <Button
              type="primary"
              icon={<FontAwesomeIcon icon={faEdit} />}
              style={{ backgroundColor: "orange" }}
            >
              O'zgartirish
            </Button>
          </Link>
        ),
        width: 300,
      },
    ],
    [i18n.language]
  );

  const getPaging = async () => {
    try {
      setLoading(true);
      const response = await api.document.getPaging(getAllParams);
      setData(response.data.data);
      setTotal(response.data.total);
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getPaging();
  }, [getAllParams]);

  return {
    state: { filterFields, columns, data, loading, total },
    actions: {},
  };
};

const DocumentsContext = createContext<any>({ state: {}, actions: {} });

export const DocumentsContextProvider: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const value = Context();
  return (
    <DocumentsContext.Provider value={value}>
      {children}
    </DocumentsContext.Provider>
  );
};

export default function useDocumentsContext() {
  return useContext<ReturnType<typeof Context>>(DocumentsContext);
}
